import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Book = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, className, onClick }, ref) => (
    <svg
      ref={ref}
      className={className}
      onClick={onClick}
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" />
      <path d="M19 17H6a2 2 0 0 0-2 2" />
    </svg>
  ),
);

export default Book;
